if (!customElements.get('wls-featured-product')) {
    class WLSFeaturedProduct extends HTMLElement {
        constructor() {
            super();

            this.handleClick = this.handleClick.bind(this);
        }

        connectedCallback() {
            this.triggers = this.querySelectorAll('[data-wls-fp-trigger]');

            this.triggers.forEach((btn) => {
                if (btn.dataset.wlsFpBound) return;

                btn.dataset.wlsFpBound = 'true';
                btn.addEventListener('click', this.handleClick);
            });
        }

        disconnectedCallback() {
            this.triggers?.forEach((btn) => {
                btn.removeEventListener('click', this.handleClick);
            });
        }

        handleClick(e) {
            e.preventDefault();

            const id = e.currentTarget.getAttribute('data-wls-fp-trigger');
            if (!id) return;

            const cta = document.querySelector('[data-cta-trigger="' + id + '"]');
            if (cta) cta.click();
        }
    }

    customElements.define('wls-featured-product', WLSFeaturedProduct);
}
